// extracted by mini-css-extract-plugin
export default {"container":"Table_container__cBwLT","hide":"Table_hide__p39fD","wrapper":"Table_wrapper__xmCXh"};